 /* lua.js generated code 0.3.0 */
 var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")

 let  CountDownCmpt = require("clover/panel/component/common/CountDownCmpt");
 let CustomeServicePanel = xClass("CustomeServicePanel", BasePanel, function () {
     // return cc.CSLoader.createNode(`cocos/lightning_rush_rank_panel_${mgr.getSkinId()}.csb`)
     return cc.CSLoader.createNode("cocos/service_service_panel.csb")
 })
 CustomeServicePanel.resource = [
     "packed/ServicePanel.pack",
 ]
 
 CustomeServicePanel.show = function (loadCb,data) {
     function onSuccess () {
         loadCb && loadCb()
         CustomeServicePanel.create(data)
     }
     preloadWithLoading(CustomeServicePanel.resource, onSuccess, function () {
         Toast.make(getText("error.tip.load_res_error"))
         loadCb && loadCb()
     }, function () {
         Toast.make(getText("error.tip.load_canceled"))
         loadCb && loadCb()
     })
 }
 CustomeServicePanel.prototype.ctor = function (data) {
     var self = this;
     // console.log("adstart adreward", adStartReward)
     BasePanel.prototype.ctor.call(self)
     self.data = data
     self.fitScreen()
     self.popup();
     self.initUI()
 
 }
 
 CustomeServicePanel.prototype.initUI = function () {
     let self = this
     let closeBtn = UIButton.create(this.getChildByName("com_close"));
     PushBounceAnim.create(closeBtn)
     closeBtn.on(UIButtonEvent.Click, ()=>{
         this.onClose()
     });
     let copyBtn = UIButton.create(this.getChildByName("button"));
     PushBounceAnim.create(copyBtn)
     copyBtn.on(UIButtonEvent.Click, ()=>{
         let self = this
         copyText("2092790832")
         Toast.make(getText("clover.text.242"))
   
     });
     copyBtn.setVisible(false)

 }

 
 
 CustomeServicePanel.prototype.onClose = function () {
     let self = this;
     BasePanel.prototype.onClose.call(self);
 
 }
 /**
  * UI适配屏幕分辨率
  */
  CustomeServicePanel.prototype.fitScreen = function () {
     var self = this
     var scaleY = display.height / GamePlayConfig_Design_Height
     var scaleX = display.width / GamePlayConfig_Design_Width
     var scale = Math.min(scaleX, scaleY)
     cc.log("fitScreen", scale)
     self._scale = scale
     self.setScale(self._scale)
 }
 module.exports = CustomeServicePanel;
 